import React, { PureComponent } from 'react';
import { endpoint } from '../helpers/constantes';
import SweetAlert from 'react-bootstrap-sweetalert';
import Paper from '@material-ui/core/Paper';
import {
  Grid,
  Table,
  Toolbar,
  SearchPanel,
  TableHeaderRow,
  PagingPanel,
  TableEditRow,
  TableEditColumn,
} from '@devexpress/dx-react-grid-material-ui';
import  Navigation from './Navigation/Navigation'
import TableCell from '@material-ui/core/TableCell';
import Select from 'react-select';
import {
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
  EditingState,
} from '@devexpress/dx-react-grid';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { modificaToken, modificaNome } from '../actions/LoginActions';
import { modificaLoader } from '../actions/LoaderActions';

const getRowId = row => row.id;

const EditButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Edit row">
    <EditIcon />
  </IconButton>
);

const DeleteButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Delete row">
    <DeleteIcon />
  </IconButton>
);

const CommitButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Save changes">
    <SaveIcon />
  </IconButton>
);

const CancelButton = ({ onExecute }) => (
  <IconButton color="secondary" onClick={onExecute} title="Cancel changes">
    <CancelIcon />
  </IconButton>
);

const commandComponents = {
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton,
};

const Command = ({ id, onExecute }) => {
  const CommandButton = commandComponents[id];
  return (
    <CommandButton
      onExecute={onExecute}
    />
  );
};

const LookupEditCellBase = ({
  availableColumnValues, value, onValueChange, ...rest}) => {
    
    return(
      <TableCell>
      <Select
        className="basic-single"
        classNamePrefix="select"     
        onChange={event => onValueChange([event.label, event.value])}        
        defaultValue={{value: rest.row.id_vlan, label: rest.row.vlan}}
        options={availableColumnValues}
      >
      </Select>
    </TableCell>
  )};

export const LookupEditCell = (LookupEditCellBase);

class ListaOlts extends PureComponent {
  constructor(props) {
    super(props);
    this.props.modificaLoader(true);
    this.state = {
      columns: [
        { name: 'nome', title: 'Caixa' },
        { name: 'vlan', title: 'Vlan' },
        { name: 'nome_olt', title: 'Olt' },
      ],
      rows: [],
      pageSizes: [5, 10, 15, 0],
      deleted: '',
      population: [],
      editingRows: [],
      editingStateColumnExtensions: [
        { columnName: 'nome_olt', editingEnabled: false },
      ],
      alert: {
        show: false,      
        title: 'Aviso',
        message: '',
        type: {
          warning: false,
          success: false,
          danger: false,
        }
      }
    };    
    this.listaCaixas();
    this.listaVlans(); 
  }

  EditCell = (props) => {
    const { column } = props;
    const availableColumnValues = this.state.population[column.name];
    if (availableColumnValues) {
      return <LookupEditCell {...props} availableColumnValues={availableColumnValues} />;
    }
    return <TableEditRow.Cell {...props} />;
  };

  listaCaixas = () => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/caixas`, {
      method: "GET",
      headers: myHeaders,
    })
    .then(result => {
      if(result.ok){
        return result.json();
      }else{
        this.setState({
          alert: {
            show: true,
            title: 'Falha',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
      }
      throw Error("Forbidden");
    })
    .then(resultJson => {
      this.setState({rows: resultJson})
      this.props.modificaLoader(false);
    })
    .catch(err => {
      this.setState({
        alert: {
          show: true,
          title: 'Falha',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  }

  listaVlans = () => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/vlans`, {
      method: "GET",
      headers: myHeaders,
    })
    .then(result => {
      if(result.ok){
        return result.json();
      }else{
        this.setState({
          alert: {
            show: true,
            title: 'Falha',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
      }
      throw Error("Forbidden");
    })
    .then(resultJson => {
      const resultFormat = resultJson.map(item => {
        return {  
          label: item.vlan,
          value: JSON.stringify(item.id),
        }
      })
      this.setState({population: { vlan: resultFormat }})
    })
    .catch(err => {
      this.setState({
        alert: {
          show: true,
          title: 'Falha',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  }

  updateCaixa = (obj) => {
    const { id, id_vlan, nome, ...newObj } = obj;
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/caixa/${id}`, {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify({nome: nome, id_vlan: id_vlan})})
      .then(result => {
        if(result.ok){
          this.listaCaixas();
          return;
        }else{
          this.setState({
            alert: {
              show: true,
              title: 'Falha ao atualizar Caixa',
              message: result.statusText,
              type: {
                warning: true,
                success: false,
                danger: false,
              }
            }
          })
        }
      })
      .catch(err => {
        this.setState({
          alert: {
            show: true,
            title: 'Erro! Estamos sem conectividade ?',
            message: err.message,
            type: {
              warning: false,
              success: false,
              danger: true,
            }
          }
        })
      })
  }

  deleteCaixa = (id) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/caixa/${id}`, {
      method: "DELETE",
      headers: myHeaders,
    })
    .then(result => {
      if(result.ok){
        return;
      }else{
        this.setState({
          alert: {
            show: true,
            title: 'Falha ao Deletar Caixa',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
      }
    })
    .catch(err => {
      this.setState({
        alert: {
          show: true,
          title: 'Erro! Estamos sem conectividade ?',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  }
  commitChanges = ({ added, changed, deleted }) => {    
    let { rows } = this.state;   
    if (changed) {     
      rows = rows.map(row => {
        if(changed[row.id]) {
         Object.keys(changed[row.id]).map(resp => {
            if(resp === 'vlan'){
              
              Object.keys(changed[row.id].vlan).map(item => {
                if(item === "0") {                  
                  row['vlan'] =  changed[row.id].vlan[item]
                }
                if(item === "1"){
                  row['id_vlan'] =  changed[row.id].vlan[item]
                }
                return null;              
              })
            }
            if(resp === 'nome') {
              row[resp] = changed[row.id][resp];
            }
            return null;
          })
          this.updateCaixa(row);
          return {...row }
        }else{
          return row
        }
      })
      return;  
    }
    if (deleted) { 
      this.setState({ deleted });
    }
    this.setState({ rows });
  }
  changeEditingRows = editingRows => this.setState({ editingRows });

  confirmDelete = () => {
    let { rows, deleted } = this.state; 
    const deletedSet = new Set(deleted);
    this.deleteCaixa(deleted);
    rows = rows.filter(row => !deletedSet.has(row.id));
    this.setState({ deleted: '', rows });
  }  

  render() {
    const { rows, columns, pageSizes  } = this.state;

    return (
      <Navigation history={this.props.history}>
        <div className="alinhamento">
          <h1>Edição de Caixas</h1>
          <Paper>
            <Grid
              rows={rows}
              columns={columns}
              getRowId={getRowId}
            >
              <SearchState defaultValue="" />
              <IntegratedFiltering />
              <PagingState
                defaultCurrentPage={0}
                defaultPageSize={5}
              />
              <IntegratedPaging />
              <EditingState
              editingRows={this.state.editingRows}
              onEditingRowsChange={this.changeEditingRows}
              onCommitChanges={this.commitChanges}
              columnExtensions={this.state.editingStateColumnExtensions}/>                     
              <Table />
              <TableHeaderRow />
              <TableEditRow
                cellComponent={this.EditCell}
              />
              <PagingPanel
              pageSizes={pageSizes}
              />
              <TableEditColumn
              showEditCommand
              showDeleteCommand
              commandComponent={Command}
              />
              <Toolbar />
              <SearchPanel />
            </Grid>          
            <Dialog
            open={!!this.state.deleted}
            >
            <DialogTitle>
  Deletar caixa
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Você tem certeza que deseja apagar esta caixa?
              </DialogContentText>
              <Paper>
                <Grid
                  rows={this.state.rows.filter(row => this.state.deleted.indexOf(row.id) > -1)}
                  columns={columns}
                >
                <Table />
                <TableHeaderRow />
                </Grid>
              </Paper>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ deleted: '' })} color="primary">
  Cancelar
              </Button>
              <Button onClick={this.confirmDelete} color="secondary">
  Deletar
              </Button>
            </DialogActions>
          </Dialog>
          </Paper>
        </div>
        <SweetAlert {...this.state.alert.type}
                title={this.state.alert.title}
                show={this.state.alert.show}
                onConfirm={() => this.setState({ ...this.state, alert: {show: false, title: ''}})}>
                {this.state.alert.message}
        </SweetAlert>
      </Navigation>
    );
  }
}

const mapStateToProps = state => ({
  token: state.LoginReducer.token,
});

export default connect(mapStateToProps, { modificaToken, modificaNome, modificaLoader })(ListaOlts);



// WEBPACK FOOTER //
// ./src/components/ListaCaixas.js